import { get, set, del } from 'idb-keyval';
import type { Persister } from '@tanstack/react-query-persist-client';
import type { Query } from '@tanstack/react-query';

const STORAGE_KEY = 'rq-cache';

// Whitelist of query keys (first segment) that survive reload.
// Keep PII / admin / volatile queries OUT.
//
// Persisted: notes, activity, timeline, organizations list, team, api-keys.
// NOT persisted: superadmin/*, search/* (query-string spam), anything else added later
// (default-deny: must be added here explicitly).
const PERSISTABLE_KEYS = new Set<string>([
    'notes',
    'deal-activity',
    'project-activity',
    'timeline',
    'activity-notes',
    'organizations',
    'team',
    'api-keys',
]);

export function shouldPersistQuery(query: Query): boolean {
    const key = query.queryKey[0];
    return (
        typeof key === 'string' &&
        PERSISTABLE_KEYS.has(key) &&
        query.state.status === 'success'
    );
}

export function createIdbPersister(): Persister {
    return {
        persistClient: async (client) => {
            await set(STORAGE_KEY, client);
        },
        restoreClient: async () => {
            return await get(STORAGE_KEY);
        },
        removeClient: async () => {
            await del(STORAGE_KEY);
        },
    };
}

export async function purgePersistedCache(): Promise<void> {
    await del(STORAGE_KEY);
}
